// colours
export const PALETTE_COLOURS = 'paletteColours';

// dashboards
export const CURRENT_DASHBOARD = 'currentDashboard';
export const DASHBOARD_LIST_SCOPE = 'dashboardListScope';
export const DASHBOARD_SCOPE = 'dashboardScope';

// widgets
export const DASHBOARD_WIDGETS = 'dashboardWidgets';
